
import React, { useState } from 'react'
import { CardElement, injectStripe } from 'react-stripe-elements'
import { default as toaster } from './Toasts'
import AddressInputs from './AddressInputs'
import TextInputField from './TextInputField'
import FormField from './FormField'
import Dialog from './Dialog'
import Button from './Button'
import Form from './Form'
import Box from './Box'

/**
 * CardForm is a credit card form.
 */

function CardForm({ name, address_line1, address_city, address_state, address_zip, address_country, buttonText = 'Save card', dialog, stripe, onSubmit }) {
  const [pending, setPending] = useState(false)

  async function submit(address) {
    setPending(true)
    const { token, error } = await stripe.createToken(address)

    if (token) {
      await onSubmit({ address, token: token.id })
    }

    if (error) {
      const { code, type, message } = error
      toaster.danger(message)
    }

    setPending(false)
  }

  const actions = dialog
    ? <Dialog.Actions>
        <Button theme="primary" pending={pending}>{buttonText}</Button>
      </Dialog.Actions>
    : <Form.Actions>
        <Button theme="primary" pending={pending}>{buttonText}</Button>
      </Form.Actions>

  const padding = dialog ? 8 : 0

  return <Form onSubmit={submit}>
    <Box paddingTop={padding} paddingX={padding}>
      <Form.Row>
        <TextInputField name="name" defaultValue={name} width="100%" label="Name" placeholder="Mark Corrigan" required />
      </Form.Row>
      <AddressInputs
        address_line1={address_line1}
        address_city={address_city}
        address_state={address_state}
        address_zip={address_zip}
        address_country={address_country} />
      <Form.Row>
        <CardInput />
      </Form.Row>
    </Box>
    {actions}
  </Form>
}

/**
 * CardInput component.
 */

function CardInput() {
  return <FormField
    marginBottom={6}
    label="Card Information"
    required
  >
    <Box
      height={32}
      paddingX={3}
      paddingTop={2}
      borderRadius={1}
      border
    >
      <CardElement hidePostalCode />
    </Box>
  </FormField>
}

export default injectStripe(CardForm)

